/**
 *    Bauhaus100 (Head)
 *
 *    @tableofcontent
 *      1. Default dependencies
 *       1.1 Touch devices
 *       1.2 Console
 *
 */


/**
 *     @section 1. Components
 */

// @section 1.1 Touch devices
import('./util/_touch-devices')
    .then((module) => {
        module.default.init()
    })
    .catch(() => {
        console.warn('Touch devices could not be loaded')
    })

// @section 1.2 Console
import('./util/_console')
    .then((module) => {
        module.default.init()
    })
    .catch(() => {
        console.warn('Console could not be loaded')
    })

// end of bau100--head.js
